import getEnvVar from './env-vars';
import { ResourcesConfig } from 'aws-amplify';

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolClientId: getEnvVar('cognitoUserPoolClientId'),
      userPoolId: getEnvVar('cognitoUserPoolId'),
      identityPoolId: getEnvVar('cognitoIdentityPoolId'),
      loginWith: {
        oauth: {
          providers: [{ custom: 'AMZNFederateOIDC' }],
          domain: getEnvVar('cognitoAppDomain').replace('https://', ''),
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [getEnvVar('cognitoRedirectUri')],
          redirectSignOut: [getEnvVar('cognitoRedirectUri')],
          responseType: 'code',
        },
      },
    },
  },
  API: {
    REST: {
      cohortApi: {
        endpoint: getEnvVar('apiBaseUrl'),
        region: getEnvVar('awsRegion'),
      },
    },
  },
};
